<template>
  <div id="input">
    <!-- <button v-on:click="testaxios()">上記の内容で送信する</button> -->
    <!-- <p>{{ tores }}</p> -->
    <a name="confurm_link"></a>
    <div v-if="confirmation === true">
          <!-- .preventを入れるとリロードされなくなる -->
          <form @submit.prevent="onsubmit">
            <p id="title">相談をご希望の場合、下記のフォームに必要事項を入力して送信してください。</p>
            <div class="company">
              <h2 class="info">会社情報&nbsp;<span class="asterisk">*</span><span>は必須項目です</span></h2>

              <div class="form">

                  <label for="work">
                    <div class="leftcalm">
                      <p class="form_name">業種&nbsp;<span class="must">*</span></p>
                    </div>
                  </label>

                  <div class="rightcalm">
                    <select name="work" v-model="work" id="vali_work" class="input_l" required>
                      <option disabled value="">選択</option>
                      <option>製造業</option>
                      <option>建設業</option>
                      <option>卸売業</option>
                      <option>小売業</option>
                      <option>サービス業</option>
                      <option>金融・保険業</option>
                      <option>その他</option>
                    </select>
                  </div>
              </div>

              <div class="form">
                <label for="people">
                  <div class="leftcalm">
                    <p class="form_name">従業員数</p>
                  </div>
                </label>
                <div class="rightcalm">
                  <input type="text" id="vali_people" v-model="people" class="input_s" pattern="[0-9\,]+$">
                  <p style="margin-left: 4px">人</p>
                </div>
              </div>

              <div class="form">
                <label for="sales">
                  <div class="leftcalm">
                    <p class="form_name">売上</p>
                  </div>
                </label>
                <div class="rightcalm">
                  <input type="text" id="sales" v-model="sales" class="input_s">
                  <p style="margin-left: 4px;">千円</p>
                </div>
              </div>

              <div class="form">
                <label for="office">
                  <div class="leftcalm">
                    <p class="form_name">事業所名&nbsp;<span class="must">*</span></p>
                  </div>
                </label>
                <div class="rightcalm">
                  <input type="text" id="vali_office" v-model="office" class="input_l" required>
                </div>
              </div>

              <div class="form">
                <label for="office-j">
                  <div class="leftcalm">
                    <p class="form_name">事業所名(ふりがな)</p>
                  </div>
                </label>
                <div class="rightcalm">
                  <input type="text" id="office-j" v-model="office_j" class="input_l">
                </div>
              </div>

              <div class="form">
                <label for="name">
                  <div class="leftcalm">
                    <p class="form_name">代表者&nbsp;氏名&nbsp;<span class="must">*</span></p>
                  </div>
                </label>
                <div class="rightcalm">
                  <input type="text" placeholder="" id="vali_name" v-model="name" class="input_l" required>
                </div>
              </div>

              <div class="form">
                <label for="name-j">
                  <div class="leftcalm">
                    <p class="form_name">代表者&nbsp;氏名(ふりがな)</p>
                  </div>
                </label>
                <div class="rightcalm">
                  <input type="text" placeholder="" id="name-j" v-model="name_j" class="input_l">
                </div>
              </div>

              <div class="form">
                <label for="age">
                  <div class="leftcalm">
                    <p class="form_name">代表者&nbsp;年齢&nbsp;<span class="must">*</span></p>
                  </div>
                </label>
                <div class="rightcalm">
                  <input type="text" id="vali_age" v-model="age" class="input_s" required pattern="[0-9]+$">
                  <p style="margin-left: 4px;">歳</p>
                </div>
              </div>

              <div class="form">
                <label for="sex">
                  <div class="leftcalm">
                    <p class="form_name">代表者&nbsp;性別</p>
                  </div>
                </label>
                <div class="rightcalm">
                  <label>
                    <input type="radio"  v-model="sex" id="vali_sex" value="男" class="sex" name="gender">
                    <p class="sex sex_content">男</p>
                  </label>
                  <label>
                    <input type="radio"  v-model="sex" id="vali_sex" value="女" class="sex" name="gender">
                    <p class="sex sex_content">女</p>
                  </label>
                </div>

              </div>

              <div class="form">
                <label for="postal-code">
                  <div class="leftcalm">
                    <p class="form_name">郵便番号</p>
                  </div>
                </label>
                <div class="rightcalm">
                  <input type="text" id="postal-code" v-model="postal_code" class="input_s">
                </div>
              </div>

              <div class="form form_residence">
                  <div class="leftcalm">
                    <p class="form_name">住所&nbsp;<span class="must">*</span></p>
                  </div>
                <div class="rightcalm">
                    <p class="select residence">
                      <label for="ken">都道府県</label>
                      <select name="ken" v-model="ken" id="vali_ken" class="input_s ken" required>
                        <option disabled value="">選択</option>
                        <option>石川県</option>
                        <option>富山県</option>
                        <option>福井県</option>
                      </select>
                    </p>
                  <div class="residence">
                    <label for="son">市区町村</label>
                    <input type="text" id="vali_son" v-model="son" class="input_m son" required>
                  </div>
                  <div class="residence residence-details">
                    <label for="son2"></label>
                    <input type="text" id="son2" v-model="son2" class="input_l" required>
                  </div>
                </div>
              </div>

              <div class="form">
                <label for="phone-number">
                  <div class="leftcalm">
                    <p class="form_name">電話番号&nbsp;<span class="must">*</span></p>
                  </div>
                </label>
                <div class="rightcalm">
                  <input type="text" id="vali_phone_number" v-model="phone_number" class="input_l" required pattern="^\d{1,5}-?\d{1,5}-?\d{1,5}$">
                </div>
              </div>

              <div class="form">
                <label for="fax">
                  <div class="leftcalm">
                    <p class="form_name">Fax番号</p>
                  </div>
                </label>
                <div class="rightcalm">
                  <input type="text" id="fax" v-model="fax" class="input_l">
                </div>
              </div>
            </div>

            <div class="consult">
              <h2 class="info">担当者様情報</h2>
              <p class="info_top_p">センターより「希望する連絡先」宛にご連絡いたします。</p>

              <div class="form">
                <label for="name-2">
                  <div class="leftcalm">
                    <p class="form_name">担当者様&nbsp;氏名&nbsp;<span class="must">*</span></p>
                  </div>
                </label>
                <div class="rightcalm">
                  <input type="text" id="vali_name_2" v-model="name_2" class="input_l" required>
                </div>
              </div>

              <div class="form">
                <label for="name-2-j">
                  <div class="leftcalm">
                    <p class="form_name">担当者様&nbsp;氏名(ふりがな)&nbsp;<span class="must">*</span></p>
                  </div>
                </label>
                <div class="rightcalm">
                  <input type="text" id="vali_name_2_j" v-model="name_2_j" class="input_l" required>
                </div>
              </div>

              <div class="form">
                <label for="reration">
                  <div class="leftcalm">
                    <p class="form_name">代表者との続柄・関係&nbsp;<span class="must">*</span></p>
                  </div>
                </label>
                <div class="rightcalm">
                  <input type="text" id="vali_reration" v-model="reration" class="input_m" required>
                </div>
              </div>

              <div class="form">
                <label for="mail">
                  <div class="leftcalm">
                    <p class="form_name">E-mail&nbsp;<span class="must">*</span></p>
                  </div>
                </label>
                <div class="rightcalm">
                  <input type="email" id="vali_mail" v-model="mail" class="input_l" required>
                </div>
              </div>

              <div class="form form_preffer">
                  <div class="leftcalm">
                    <p class="form_name">希望する連絡先&nbsp;<span class="must">*</span></p>
                  </div>
                <div class="rightcalm">
                  <p>事業承継の件で、ご連絡しても良い連絡先を入力してください。<br class="tablet_br">(電話番号・E-mailなど)</p>
                  <input type="text" id="vali_contact" v-model="contact" class="input_l" required>
                </div>
              </div>
            </div>

            <div class="consult_contents">
              <h2 class="info">相談内容</h2>

              <div class="form form_season">
                  <div class="leftcalm">
                    <p class="form_name">時期</p>
                  </div>
                <div class="rightcalm">
                  <div class="season">
                    <label>
                      <input type="radio" name="season" v-model="season" value="すでに事業承継を行っている" class="season_form">
                      <p class="season_form season_content">すでに事業承継を行っている</p>
                    </label><br>
                    <label>
                      <input type="radio" name="season" v-model="season" value="直近で事業承継を行おうと思っている" class="season_form">
                      <p class="season_form season_content">直近で事業承継を行おうと思っている</p>
                    </label><br>
                    <label>
                      <input type="radio" name="season" v-model="season" value="将来の事業承継に備えて相談したい" class="season_form">
                      <p class="season_form season_content">将来の事業承継に備えて相談したい</p>
                    </label>
                  </div>
                  <div id="left">
                    <p class="flex">(概ね</p>
                    <input type="text" class="flex input_s" v-model="flex">
                    <p class="flex" style="margin-left: 4px;">年後)</p>
                  </div>
                </div>
              </div>

              <div class="form form_content">
                <div class="leftcalm">
                    <div class="leftcalm">
                      <p class="form_name">内容</p>
                    </div>
                </div>
                <div class="rightcalm">
                  <div id="check-box">
                    <label class="check new_label">
                      <input type="checkbox" name="content" v-model="content1" true-value="経営改善" false-value="" class="content_check">
                      <p class="content_check">経営改善</p>
                    </label>
                    <label class="check new_label">
                      <input type="checkbox" name="content" v-model="content2" true-value="後継者" false-value="" class="content_check">
                      <p class="content_check">後継者</p>
                    </label>
                    <label class="check new_label">
                      <input type="checkbox" name="content" v-model="content3" true-value="経営権・株式" false-value="" class="content_check">
                      <p class="content_check">経営権・株式</p>
                    </label><br class="non_pc">
                    <label class="check new_label">
                      <input type="checkbox" name="content" v-model="content4" true-value="税務(相続・贈与)" false-value="" class="content_check">
                      <p class="content_check">税務(相続・贈与)</p>
                    </label>
                    <label class="check new_label">
                      <input type="checkbox" name="content" v-model="content5" true-value="資金調達" false-value="" class="content_check">
                      <p class="content_check">資金調達</p>
                    </label><br class="non_pc">
                    <label class="check new_label">
                      <input type="checkbox" name="content" v-model="content6" true-value="債務・個人保証" false-value="" class="content_check">
                      <p class="content_check">債務・個人保証</p>
                    </label><br class="non_sp">
                    <label class="check new_label">
                      <input type="checkbox" name="content" v-model="content7" true-value="M&A" false-value="" class="content_check">
                      <p class="content_check">M&A</p>
                    </label>
                  </div>
                  <label for="other">その他<br>
                    <textarea type="text" id="other" v-model="other" class="input_l content_textarea"></textarea>
                  </label>
                </div>
              </div>
            </div>
            <div class="btn_wrapper">
              <button type="submit" @click="checkFrom" class="check_form_btn">入力内容を確認</button>
            </div>
          </form>
    </div>

    <!-- 以下、確認画面 -->
    <div v-else class="confirmation-form">
        <p id="title">相談をご希望の場合、下記のフォームに必要事項を入力して送信してください。</p>
        <div class="company">
          <h2 class="info">会社情報&nbsp;<span class="asterisk">*</span><span>は必須項目です</span></h2>
          <div class="form">
              <label for="work">
                <div class="leftcalm">
                  <p class="form_name">業種&nbsp;<span class="must">*</span></p>
                </div>
              </label>
              <div class="rightcalm">
                <p>{{ work }}</p>
              </div>
          </div>
          <div class="form">
            <label for="people">
              <div class="leftcalm">
                <p class="form_name">従業員数</p>
              </div>
            </label>
            <div class="rightcalm">
              <p>{{ people }}</p>
              <p style="margin-left: 4px">人</p>
            </div>
          </div>
          <div class="form">
            <label for="sales">
              <div class="leftcalm">
                <p class="form_name">売上</p>
              </div>
            </label>
            <div class="rightcalm">
              <p>{{ sales }}</p>
              <p style="margin-left: 4px;">千円</p>
            </div>
          </div>
          <div class="form">
            <label for="office">
              <div class="leftcalm">
                <p class="form_name">事業所名&nbsp;<span class="must">*</span></p>
              </div>
            </label>
            <div class="rightcalm">
              <p>{{ office }}</p>
            </div>
          </div>
          <div class="form">
            <label for="office-j">
              <div class="leftcalm">
                <p class="form_name">事業所名(ふりがな)</p>
              </div>
            </label>
            <div class="rightcalm">
              <p>{{ office_j }}</p>
            </div>
          </div>
          <div class="form">
            <label for="name">
              <div class="leftcalm">
                <p class="form_name">代表者&nbsp;氏名&nbsp;<span class="must">*</span></p>
              </div>
            </label>
            <div class="rightcalm">
              <p>{{ name }}</p>
            </div>
          </div>
          <div class="form">
            <label for="name-j">
              <div class="leftcalm">
                <p class="form_name">代表者&nbsp;氏名(ふりがな)</p>
              </div>
            </label>
            <div class="rightcalm">
              <p>{{ name_j }}</p>
            </div>
          </div>
          <div class="form">
            <label for="age">
              <div class="leftcalm">
                <p class="form_name">代表者&nbsp;年齢&nbsp;<span class="must">*</span></p>
              </div>
            </label>
            <div class="rightcalm">
              <p>{{ age }}</p>
              <p style="margin-left: 4px;">歳</p>
            </div>
          </div>
          <div class="form">
            <label for="sex">
              <div class="leftcalm">
                <p class="form_name">代表者&nbsp;性別</p>
              </div>
            </label>
            <div class="rightcalm">
              <p>{{ sex }}</p>
            </div>
          </div>
          <div class="form">
            <label for="postal-code">
              <div class="leftcalm">
                <p class="form_name">郵便番号</p>
              </div>
            </label>
            <div class="rightcalm">
              <p> {{ postal_code }}</p>
            </div>
          </div>
          <div class="form form_residence fix_confirm">
              <div class="leftcalm">
                <p class="form_name">住所&nbsp;<span class="must">*</span></p>
              </div>
            <div class="rightcalm">
              <div class="select residence">
                <p>{{ ken }}</p>
              </div>
              <div class="residence">
                <p>{{ son }}</p>
              </div>
              <div class="residence">
                <p>{{ son2 }}</p>
              </div>
            </div>
          </div>
          <div class="form">
            <label for="phone-number">
              <div class="leftcalm">
                <p class="form_name">電話番号&nbsp;<span class="must">*</span></p>
              </div>
            </label>
            <div class="rightcalm">
              <p>{{ phone_number }}</p>
            </div>
          </div>
          <div class="form">
            <label for="fax">
              <div class="leftcalm">
                <p class="form_name">Fax番号</p>
              </div>
            </label>
            <div class="rightcalm">
              <p>{{ fax }}</p>
            </div>
          </div>
        </div>
        <div class="consult">
          <h2 class="info">担当者様情報</h2>
          <p class="info_top_p">事務局より「希望する連絡先」宛にご連絡いたします。</p>
          <div class="form">
            <label for="name-2">
              <div class="leftcalm">
                <p class="form_name">担当者様&nbsp;氏名&nbsp;<span class="must">*</span></p>
              </div>
            </label>
            <div class="rightcalm">
              <p>{{ name_2 }}</p>
            </div>
          </div>
          <div class="form">
            <label for="name-2-j">
              <div class="leftcalm">
                <p class="form_name">担当者様&nbsp;氏名(ふりがな)&nbsp;<span class="must">*</span></p>
              </div>
            </label>
            <div class="rightcalm">
              <p>{{ name_2_j }}</p>
            </div>
          </div>
          <div class="form">
            <label for="reration">
              <div class="leftcalm">
                <p class="form_name">代表者との続柄・関係&nbsp;<span class="must">*</span></p>
              </div>
            </label>
            <div class="rightcalm">
              <p>{{ reration }}</p>
            </div>
          </div>
          <div class="form">
            <label for="mail">
              <div class="leftcalm">
                <p class="form_name">E-mail&nbsp;<span class="must">*</span></p>
              </div>
            </label>
            <div class="rightcalm">
              <p>{{ mail }}</p>
            </div>
          </div>
          <div class="form form_preffer fix_confirm">
              <div class="leftcalm">
                <p class="form_name">希望する連絡先&nbsp;<span class="must">*</span></p>
              </div>
            <div class="rightcalm">
              <p>{{ contact }}</p>
            </div>
          </div>
        </div>
        <div class="consult_contents">
          <h2 class="info">相談内容</h2>
          <div class="form form_season fix_confirm_season">
              <div class="leftcalm">
                <p class="form_name">時期</p>
              </div>
            <div class="rightcalm">
              <div class="season">
                  <p>{{ season }}</p>
              </div>
              <div v-if="season === '将来の事業承継に備えて相談したい'" id="left">
                <p class="flex">(概ね</p>
                <p>{{ flex }}</p>
                <p class="flex" style="margin-left: 4px;">年後)</p>
              </div>
            </div>
          </div>
          <div class="form form_content fix_confirm_content">
            <div class="leftcalm">
                <div class="leftcalm">
                  <p class="form_name">内容</p>
                </div>
            </div>
            <div class="rightcalm">
              <div id="check-box">
                <p>
                  <span v-if="content1 == '経営改善'" style="margin-right:1em;">{{ content1 }}</span>
                  <span v-if="content2 == '後継者'" style="margin-right:1em;">{{ content2 }}</span>
                  <span v-if="content3 == '経営権・株式'" style="margin-right:1em;">{{ content3 }}</span>
                  <span v-if="content4 == '税務(相続・贈与)'" style="margin-right:1em;">{{ content4 }}</span>
                  <span v-if="content5 == '資金調達'" style="margin-right:1em;">{{ content5 }}</span>
                  <span v-if="content6 == '債務・個人保証'" style="margin-right:1em;">{{ content6 }}</span>
                  <span v-if="content7 == 'M&A'" style="margin-right:1em;">{{ content7 }}</span>
                </p>
              </div>
              <label v-if="other" for="other">
                <p>その他：{{ other }}</p>
              </label>
            </div>
          </div>
        </div>
        <div class="btn_wrapper confirm_btn_wrapper">
          <!-- <button v-on:click="testaxios()" class="send_btn">送信する</button> -->
          <button v-on:click="completed_form()" class="send_btn">送信する</button>
          <button v-on:click="inversion(true)" class="back_btn">戻る</button>
          <!-- <p>{{ tores }}</p> -->
        </div>
        <div class="confirm">
          <p>
            ご提出いただいた個人情報は、法令の定めのある場合やご本人が同意している場合を除き、目的外の利用やご紹介いただいた団体以外の第三者に提供することはありません。
            <a href="https://www.tonio.or.jp/tonio/privacy/" target="_blank">プライバシーポリシー</a>はこちら。
          </p>
          <div class="btn_wrapper">
            <a href="#" onclick="window.print();" class="print_btn">
              <img src="../assets/btn_print.png" alt="このページを印刷する">
            </a>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Input',
  data () {
    return {
      work: '',
      people: '',
      sales: '',
      office: '',
      office_j: '',
      name: '',
      name_j: '',
      age: '',
      sex: '',
      postal_code: '',
      ken: '',
      son: '',
      son2: '',
      phone_number: '',
      fax: '',
      name_2: '',
      name_2_j: '',
      reration: '',
      mail: '',
      contact: '',
      season: '',
      flex: '',
      content1: '',
      content2: '',
      content3: '',
      content4: '',
      content5: '',
      content6: '',
      content7: '',
      other: '',
      confirmation: true,
      er_work: '',
      er_people: '',
      er_office: '',
      er_name: '',
      er_age: '',
      er_sex: '',
      er_ken: '',
      er_phone_number: '',
      er_name_2: '',
      er_name_2_j: '',
      er_reration: '',
      er_mail: '',
      er_contact: '',
      todos: 'test',
      tores: null,
      completed: false
    }
  },
  props: ['qitems', 'qresult', 'qresultmail'],

  watch: {
    // 売上の3桁区切り
    sales (newval, oldval) {
        const checking = /[^0-9\,]/
        if(newval.match(checking)) {
          return
        }
        this.sales = String(this.sales).split(',').join('')
        this.sales = Number(this.sales).toLocaleString();
        if(this.sales == 0) {
          this.sales = '';
        }
    },
    // 従業員の3桁区切り
    people (newval, oldval) {
      const checking = /[^0-9\,]/
      if(this.people == "0") {
        this.people = '';
        return
      }
      else if(newval.match(checking)) {
        return
      }
      this.people = String(this.people).split(',').join('')
      this.people = Number(this.people).toLocaleString();
    },
  },

  methods: {

    onsubmit () {
      // this.result = Object.assign({}, this.form);
      this.inversion(false);
    },

    checkFrom: function(){
      var errorCheck = false;
      if (!this.work){
        var target = document.getElementById("vali_work");
        target.style.border="2px solid #BF1717";
        errorCheck = true;
      } else {
        var target = document.getElementById("vali_work");
        target.style.border="1px solid #CCCCCC";
      }

      if (!this.validPeople(this.people)){
        target = document.getElementById("vali_people");
        target.style.border="2px solid #BF1717";
        errorCheck = true;
      } else {
        var target = document.getElementById("vali_people");
        target.style.border="1px solid #CCCCCC";
      }

      if (!this.validSales(this.sales)){
        target = document.getElementById("sales");
        target.style.border="2px solid #BF1717";
        errorCheck = true;
      } else {
        var target = document.getElementById("sales");
        target.style.border="1px solid #CCCCCC";
      }

      if (!this.office){
        var target = document.getElementById("vali_office");
        target.style.border="2px solid #BF1717";
        errorCheck = true;
      } else {
        var target = document.getElementById("vali_office");
        target.style.border="1px solid #CCCCCC";
      }

      if (!this.name){
        var target = document.getElementById("vali_name");
        target.style.border="2px solid #BF1717";
        errorCheck = true;
      } else {
        var target = document.getElementById("vali_name");
        target.style.border="1px solid #CCCCCC";
      }


      if (!this.age){
        var target = document.getElementById("vali_age");
        target.style.border="2px solid #BF1717";
        errorCheck = true;
      } else if (!this.validAge(this.age)){
        var target = document.getElementById("vali_age");
        target.style.border="2px solid #BF1717";
        errorCheck = true;
      } else {
        var target = document.getElementById("vali_age");
        target.style.border="1px solid #CCCCCC";
      }

      if (!this.ken){
        var target = document.getElementById("vali_ken");
        target.style.border="2px solid #BF1717";
        errorCheck = true;
      } else {
        var target = document.getElementById("vali_ken");
        target.style.border="1px solid #CCCCCC";
      }

      if (!this.son){
        var target = document.getElementById("vali_son");
        target.style.border="2px solid #BF1717";
        errorCheck = true;
      } else {
        var target = document.getElementById("vali_son");
        target.style.border="1px solid #CCCCCC";
      }

      if (!this.son2){
        var target = document.getElementById("son2");
        target.style.border="2px solid #BF1717";
        errorCheck = true;
      } else {
        var target = document.getElementById("son2");
        target.style.border="1px solid #CCCCCC";
      }

      if (!this.phone_number){
        var target = document.getElementById("vali_phone_number");
        target.style.border="2px solid #BF1717";
        errorCheck = true;
      } else if (!this.validNumber(this.phone_number)){
        var target = document.getElementById("vali_phone_number");
        target.style.border="2px solid #BF1717";
        errorCheck = true;
      } else {
        var target = document.getElementById("vali_phone_number");
        target.style.border="1px solid #CCCCCC";
      }

      if (!this.name_2){
        var target = document.getElementById("vali_name_2");
        target.style.border="2px solid #BF1717";
        errorCheck = true;
      } else {
        var target = document.getElementById("vali_name_2");
        target.style.border="1px solid #CCCCCC";
      }

      if (!this.name_2_j){
        var target = document.getElementById("vali_name_2_j");
        target.style.border="2px solid #BF1717";
        errorCheck = true;
      } else {
        var target = document.getElementById("vali_name_2_j");
        target.style.border="1px solid #CCCCCC";
      }

      if (!this.reration){
        var target = document.getElementById("vali_reration");
        target.style.border="2px solid #BF1717";
        errorCheck = true;
      } else {
        var target = document.getElementById("vali_reration");
        target.style.border="1px solid #CCCCCC";
      }

      if (!this.mail){
        var target = document.getElementById("vali_mail");
        target.style.border="2px solid #BF1717";
        errorCheck = true;
      } else if (!this.validEmail(this.mail)){
        var target = document.getElementById("vali_mail");
        target.style.border="2px solid #BF1717";
        errorCheck = true;
      } else {
        var target = document.getElementById("vali_mail");
        target.style.border="1px solid #CCCCCC";
      }

      if (!this.contact){
        var target = document.getElementById("vali_contact");
        target.style.border="2px solid #BF1717";
        errorCheck = true;
      } else {
        var target = document.getElementById("vali_contact");
        target.style.border="1px solid #CCCCCC";
      }

      //ジャンプ
      var clientRect = document.getElementById("title").getBoundingClientRect();
      var py = window.pageYOffset + clientRect.top ;
      if(errorCheck) {
        scrollTo(0,py);
      }
      if(!errorCheck) {
        scrollTo(0,0);
      }
    },
    validEmail: function (mail) {
      var re = /[^\s]@[^\s]/;
      return re.test(mail);
    },
    validAge: function (age) {
      var re = /^[0-9]+$/;
      return re.test(age);
    },
    validNumber: function (phone){
      var re = /^\d{1,5}-?\d{1,5}-?\d{1,5}$/;
      return re.test(phone);
    },
    validPeople: function(people){
      var re = /^[0-9\,]*$/;
      return re.test(people);
    },
    validSales: function(sales){
      var re = /^[0-9\,]*$/;
      return re.test(sales);
    },

    inversion: function(flg){
      this.confirmation = !this.confirmation;
      if(flg){
        //ジャンプ
        var clientRect = document.getElementById("title").getBoundingClientRect();
        var py = window.pageYOffset + clientRect.top ;
        scrollTo(0,py);
      }
    },
    completed_form: function (){
      var params = new URLSearchParams();
      params.append('text', this.todos);
      params.append('work',this.work);
      params.append('people',this.people);
      params.append('sales',this.sales);
      params.append('office',this.office);
      params.append('office_j',this.office_j);
      params.append('name',this.name);
      params.append('name_j',this.name_j);
      params.append('age',this.age);
      params.append('sex',this.sex);
      params.append('postal_code',this.postal_code);
      params.append('ken',this.ken);
      params.append('son',this.son);
      params.append('son2',this.son2);
      params.append('phone_number',this.phone_number);
      params.append('fax',this.fax);
      params.append('name_2',this.name_2);
      params.append('name_2_j',this.name_2_j);
      params.append('reration',this.reration);
      params.append('mail',this.mail);
      params.append('contact',this.contact);

      params.append('season',this.season);
      if('将来の事業承継に備えて相談したい' === this.season){
        params.append('flex',this.flex);
      } else {
        params.append('flex','');
      }
      params.append('content1',this.content1);
      params.append('content2',this.content2);
      params.append('content3',this.content3);
      params.append('content4',this.content4);
      params.append('content5',this.content5);
      params.append('content6',this.content6);
      params.append('content7',this.content7);
      params.append('other',this.other);
      params.append('qresult',this.qresultmail);
      params.append('token',token);

      for (var key in this.qitems){
        if(this.qitems[key].answer){
          params.append('qitems['+key+']['+this.qitems[key].number+'. '+this.qitems[key].statement+']',this.qitems[key].answer);
        }
      }

      axios.post(site_url + '/mail/',params)
        .then((response) => {
          this.tores = response.data;
          this.$parent.completed = true;
          scrollTo(0,0);
        })
        .catch((error) => {
          this.tores = error;
        });
    }
  }
}
</script>

<style lang="scss">
#input {

  textarea {
    font-size: 100%;
    padding: 5px;
  }

  select {
    font-size: 100%;
  }

  margin-top: 80px;
  text-align: left;

  // PC/SPで表示/非表示を切り替えるもの
  .non_sp {
    display: inline;
  }
  .non_pc {
    display: none;
  }

  #title {
    color: #BF1717;
    font-weight: bold;
    font-size: 21px;
    line-height: 48px;
    text-align: center;
  }

  .must {
    color: #BF1717;
    font-size: 20px;
    font-weight: bold;
  }

  .company, .consult, .consult_contents {


    h2 {
      background-image: url("../assets/bg_h2.gif");
      background-repeat : no-repeat;
      padding-top: 15px;
      margin-bottom: 20px;

      span {
        font-weight: bold;
        font-size: 14px;
        line-height: 30px;
        display: inline-block;
      }
      .asterisk{
        font-size: 18px;
        margin-left: 1em;
        font-weight: bold;
        color: #BF1717;
      }
    }

    .form {
      height: 54px;
      display: flex;


      .leftcalm {
        width: 200px;
        display: block;
        align-items: center;
        // height: 100%;
        // display: inline-block;

        .form_name {
          padding: 15px 10px;
          width: 200px;
        }
      }

      .rightcalm {
        padding: 10px;

        p {
            display: inline;
          }

        select {
          border-radius: 0;
        }

        input {
          height: 32px;
          font-size: 100%;
          text-indent: 1em;
        }

        .input_l, .input_m, .input_s {
          height: 32px;
          background-color: #fff;
          border: 1px solid #CCCCCC;
        }

        .input_l {
          width: 400px;
        }

        .input_m {
          width: 200px;
        }

        .input_s {
          width: 100px;
        }

        .sex {
          display: inline-block;
          vertical-align: middle;
        }

        .sex_content {
          margin-left: 4px;
          margin-right: 24px;
        }
      }
    }
  }
  .confirmation-form{
      .rightcalm{
        @media all and (min-width: 768px) {
           padding: 15px 10px !important;
        }
      }
    }
  .company {

    h2 {
      margin-top: 20px;
    }

    .form {
      .rightcalm {
        .residence {
          display: inline-block;
          margin-bottom: 10px;

          .ken, .son {
            margin-left: 12px;
            margin-right: 24px;
          }
        }
        .residence-details{
          width: 100%;
        }
      }
    }

    .form_residence {
      height: 98px;
    }

    .form:nth-child(2n) {
      background-color: #F6F6F6;
    }
  }

  .consult {

    h2 {
      margin-top: 40px;
    }

    .info_top_p {
      font-size: 16px;
      margin-bottom: 20px;
    }

    .form:nth-child(2n+1) {
      background-color: #F6F6F6;
    }


    .form_preffer {
      height: 90px;

      // 画面が768pxのとき、崩れるため修正
      @media screen and (min-width:768px) and ( max-width:870px) {
        height: 115px;
      }

      .rightcalm {
        input {
          margin-top: 10px;
        }
        .tablet_br {
          display: none;
          // 画面が768pxのとき、崩れるため修正
          @media screen and (min-width:768px) and ( max-width:870px) {
            display: inline;
          }
        }
      }
    }
  }

  .consult_contents {

    h2 {
      margin-top: 40px;
    }

    .form_season {
      height: 146px;
      padding: 0 0 10px ;
      .season {

        p {
            margin-left: 4px;
        }

        .season_form {
          display: inline-block;
          vertical-align: middle;
        }
      }

      #left {
        input {
          margin-left: 4px;
        }
      }
    }

    .form_content {
      height: 100%;
      padding: 0 0 10px !important;
      .rightcalm {

        .content_check {
          display: inline-block;
          vertical-align: middle;
        }

        .check {
          p {
            margin-right: 24px;
            margin-left: 3px;
          }
        }
        label[for="other"] {
          input {
            height: 68px;
            margin-top: 10px;
          }
        }
      }
    }

    .form:nth-child(2n) {
      background-color: #F6F6F6;
    }
  }

  .btn_wrapper {
    text-align: center;
    margin-top: 40px;

    .check_form_btn {
      width: 320px;
      height: 60px;
      background-color: #BF1717;
      font-weight: bold;
      font-size: 20px;
      line-height: 20px;
      color: #fff;
      border: none;
    }

    .check_form_btn:hover {
      opacity: 0.7;
    }
  }

  .send_btn, .back_btn {
    width: 320px;
    height: 60px;
    font-weight: bold;
    font-size: 20px;
    line-height: 20px;
    color: #fff;
    margin-bottom: 40px;
    margin-right: 10px;
    margin-left: 10px;
    border: none;
  }

  .send_btn:hover, .back_btn:hover {
    opacity: 0.7;
  }

  .send_btn {
    background-color: #BF1717;
  }

  .back_btn {
    background-color: #999999;
  }

  .fix_confirm {
    height: 54px !important;
  }

  .fix_confirm_season {
    height: auto !important;
    padding: 0 !important;
  }

  .dix_confirm_content {
    height: 100% !important;
  }

  .content_textarea {
    min-height: 68px !important;
    max-width: 390px !important;
    width: -webkit-fill-available !important;
  }

  // 確認画面の要素
  .confirm {
    p {
      margin-bottom: 20px;

      a {
        color: #000;
      }

      a:hover {
        color: #bd1717;
        text-decoration: none;
      }
    }

    .btn_wrapper {
      text-align: center;
      margin-top: 0;

      .print_btn{
        display: inline-block;

        img {
          @media screen and (min-width:768px) {
            width: 320px;
          }
          @media screen and (max-width:767px) {
            width: 100%;
          }
        }
      }

      .print_btn:hover {
        opacity: 0.7;
      }
    }
  }

  // 以下、SP（スマホ以下）
  @media all and (max-width: 767px) {
    margin-top: 40px;

    //PC/SPで表示/非表示を切り替えるもの
    .non_sp {
      display: none;
    }
    .non_pc {
      display: inline;
    }

    #title {
      font-weight: bold;
      font-size: 18px;
      line-height: 29px;

      h2 {
        span {
          font-weight: bold;
          font-size: 14px;
          line-height: 27px;
        }
      }
    }

    .company, .consult, .consult_contents {

      h2 {
        margin-bottom: 10px;
      }

      .form {
        height: 84px;
        display: block;

        .leftcalm {
          width: 100%;
          height: 20px;
          display: inline-block;

          .form_name {
            padding: 10px 10px 0 10px;
          }
        }

        .rightcalm {
          .input_l {
            width: 100%;
            display: inline-block;
          }
        }
      }
    }

    .company {
      .form_residence {
        height: 172px;
      }
    }

    .consult {

      .info_top_p {
        font-size: 15px;
        margin-bottom: 10px;
      }

      .form_preffer {
        height: 145px;
      }
    }

    .consult_contents {

      .form_season, .form_content {
        padding: 0 10px 10px 10px;
      }

      .form_content {
        height: 100%;
      }

      .form_season {
        height: 174px;
      }
    }

    .btn_wrapper {
      margin-top: 20px;
    }

    .confirm_btn_wrapper {
      margin-top: 20px;

      .send_btn, .back_btn {
        width: 100%;
        font-weight: bold;
        font-size: 20px;
        line-height: 20px;
        margin: 10px 0;
      }
    }

    // 確認画面の要素
    .confirm {
      p {
        margin-top: 20px;
        font-size: 16px;
      }
    }

    .fix_confirm {
      height: 84px !important;
    }

    .fix_confirm_season {
      height: 105px !important;
    }
  }
}

@media print {
  #input {

  margin-top: 80px;
  text-align: left;

  // PC/SPで表示/非表示を切り替えるもの
  .non_sp {
    display: inline;
  }
  .non_pc {
    display: none;
  }

  #title {
    color: #BF1717;
    font-weight: bold;
    font-size: 21px;
    line-height: 48px;
    text-align: center;
  }

  .company, .consult, .consult_contents {


    h2 {
      background-image: url("../assets/bg_h2.gif");
      background-repeat : no-repeat;
      padding-top: 15px;
      margin-bottom: 20px;

      span {
        font-weight: bold;
        font-size: 14px;
        line-height: 30px;
        display: inline-block;
        margin-left: 1em;
      }
    }

    .form {
      height: 54px;
      display: flex;


      .leftcalm {
        width: 200px;
        .form_name {
          padding: 15px 10px;
          width: 200px;
        }
      }

      .rightcalm {
        padding: 10px;

        p {
            display: inline;
          }

        select {
          border-radius: 0;
        }

        input {
          height: 32px;
          font-size: 100%;
          text-indent: 1em;
        }

        .input_l, .input_m, .input_s {
          height: 32px;
          background-color: #fff;
          border: 1px solid #CCCCCC;

        }

        .input_l {
          width: 400px;
        }

        .input_m {
          width: 200px;
        }

        .input_s {
          width: 100px;
        }

        .sex {
          display: inline-block;
          vertical-align: middle;
        }

        .sex_content {
          margin-left: 4px;
          margin-right: 24px;
        }
      }
    }
  }
  .confirmation-form{
      .rightcalm{
        @media all and (min-width: 768px) {
           padding: 15px 10px !important;
        }
      }
    }
  .company {

    h2 {
      margin-top: 20px;
    }

    .form {
      .rightcalm {
        .residence {
          display: inline-block;
          margin-bottom: 10px;

          .ken, .son {
            margin-left: 12px;
            margin-right: 24px;
          }
        }
      }
    }

    .form_residence {
      height: 98px;
    }

    .form:nth-child(2n) {
      background-color: #F6F6F6;
    }
  }

  .consult {

    h2 {
      margin-top: 40px;
    }

    .info_top_p {
      font-size: 16px;
      margin-bottom: 20px;
    }

    .form:nth-child(2n+1) {
      background-color: #F6F6F6;
    }


    .form_preffer {
      height: 90px;

      .rightcalm {
        input {
          margin-top: 10px;
        }
      }
    }
  }

  .consult_contents {

    h2 {
      margin-top: 40px;
    }

    .form_season {
      height: 146px;
      padding: 0 0 10px ;
      .season {

        p {
            margin-left: 4px;
        }

        .season_form {
          display: inline-block;
          vertical-align: middle;
        }
      }

      #left {
        input {
          margin-left: 4px;
        }
      }
    }

    .form_content {
      height: 100%;
      padding: 0 0 10px !important;
      .rightcalm {

        .content_check {
          display: inline-block;
          vertical-align: middle;
        }

        .check {
          p {
            margin-right: 24px;
            margin-left: 3px;
          }
        }
        label[for="other"] {
          input {
            height: 68px;
            margin-top: 10px;
          }
        }
      }
    }

    .form:nth-child(2n) {
      background-color: #F6F6F6;
    }
  }

  .btn_wrapper {
    text-align: center;
    margin-top: 50px;

    .check_form_btn {
      width: 320px;
      height: 60px;
      background-color: #BF1717;
      font-weight: bold;
      font-size: 20px;
      line-height: 20px;
      color: #fff;
    }

    .check_form_btn:hover {
      opacity: 0.7;
    }
  }

  .send_btn, .back_btn {
    width: 320px;
    height: 60px;
    font-weight: bold;
    font-size: 20px;
    line-height: 20px;
    color: #fff;
    margin-bottom: 40px;
    margin-right: 10px;
    margin-left: 10px;
  }

  .send_btn:hover, .back_btn:hover {
    opacity: 0.7;
  }

  .send_btn {
    background-color: #BF1717;
  }

  .back_btn {
    background-color: #999999;
  }

  .fix_confirm {
    height: 54px !important;
  }

  .fix_confirm_season {
    height: auto !important;
    padding: 0 !important;
  }

  .dix_confirm_content {
    height: 100% !important;
  }

  .content_textarea {
    min-height: 68px !important;
  }

  // 確認画面の要素
  .confirm {
    p {
      margin-bottom: 20px;

      a {
        color: #000;
      }

      a:hover {
        color: #bd1717;
        text-decoration: none;
      }
    }

    .btn_wrapper {
      text-align: center;
      margin-top: 0;

      .print_btn{
        display: inline-block;
      }
      .print_btn:hover {
        opacity: 0.7;
      }
    }
  }
  .btn_wrapper{
    display: none;
  }
    // 確認画面の要素
    .confirm {
      p {
        margin-top: 20px;
        font-size: 16px;
      }
    }

    .fix_confirm {
      height: 84px !important;
    }

    .fix_confirm_season {
      height: 105px !important;
    }
  }
}
</style>
